// open hamburger icon as a fullwidth circle

$(document).ready(function() {

    // Desktop Navigation
    var opendesktopnavigation_css_top = $('#open-desktop-navigation').css('top');
    var opendesktopnavigation_css_left = $('#open-desktop-navigation').css('left');
    var opendesktopnavigation_css_width = $('#open-desktop-navigation').css('width');
    var opendesktopnavigation_css_height = $('#open-desktop-navigation').css('height');
    var xsize = 2000,
        ysize = 2000;

    // Click Event
    $('.desktop-navigation-trigger').click(function(){
        var $this = $('#open-desktop-navigation');
        var dpos = $this.position();
        var dwidth = $this.width();
        var dheight = $this.height();
        $this.animate({
            top: dpos.top - ysize,
            left: dpos.left - xsize,
            width: dwidth + (2 * xsize),
            height: dheight + (2 * ysize),
            opacity: 1
        }, {
            duration: 800,
            easing: 'swing'
        });

        // Show Desktop Navigation
        $('#desktop-navigation-wrapper').delay(500).fadeIn('normal');

        // Make sure body can't scroll
        $('html, body').css({ overflow: 'hidden', height: '100%' });

        /*
        $('.page-section-overlay').delay(900).queue(function(next) {
            $(this).addClass("show-content");
            next();
        });
        */
    });

    // Mobile Navigation
    $('.mobile-navigation-trigger').click(function(){
        // Show n hide Mobile Navigation
        var nav = $('#mobile-navigation-wrapper');
        if(nav.is(':visible')){
            nav.fadeOut('normal');
            $('html, body').css({ overflow: 'auto', height: 'auto' });
        } else {
            nav.fadeIn('normal');
            $('html, body').css({ overflow: 'hidden', height: '100%' });
        }
    });

});



// WEBPACK FOOTER //
// ./assets/js/features/navigation.js